var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0568 3.64753H9.40203V4.70943H11.5258V9.48796H3.03065V4.70943H5.68539V6.30227L8.34013 4.17848L5.68539 2.05469V3.64753H2.4997C2.35888 3.64753 2.22383 3.70347 2.12426 3.80304C2.02469 3.90262 1.96875 4.03766 1.96875 4.17848V10.0189C1.96875 10.1597 2.02469 10.2948 2.12426 10.3943C2.22383 10.4939 2.35888 10.5499 2.4997 10.5499H12.0568C12.1976 10.5499 12.3326 10.4939 12.4322 10.3943C12.5318 10.2948 12.5877 10.1597 12.5877 10.0189V4.17848C12.5877 4.03766 12.5318 3.90262 12.4322 3.80304C12.3326 3.70347 12.1976 3.64753 12.0568 3.64753Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxRepeat);
export default __webpack_public_path__ + "static/media/bx-repeat.caf07c3c45af5e77a9f8996578c93fe7.svg";
export { ForwardRef as ReactComponent };